var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "bg-thank d-flex align-items-center" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-lg-6 offset-lg-3" }, [
            _c("div", { staticClass: "box-message text-center" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("p", { staticStyle: { "line-height": "32px" } }, [
                  _vm._v(
                    "ขอขอบคุณที่สนใจบริการ Big Cleaning\n                ทางเจ้าหน้าที่ได้รับข้อมูลของคุณลูกค้าแล้ว\n                ภายใน 1-2 ชม. จะมีเจ้าหน้าที่ติดต่อกลับ เพื่อขอทราบข้อมูลเพิ่มเติม ขออภัยถ้าหากเกิดความล่าช้า"
                  )
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("ขอบพระคุณมากค่ะ")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info btn-block",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$router.replace({
                          path: "/big-cleaning",
                          replace: true
                        })
                      }
                    }
                  },
                  [_vm._v("\n                กลับ\n              ")]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-285aaf31", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-285aaf31","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/ThankUsingServiceBigCleaning.vue
// module id = 1538
// module chunks = 0